import { combineReducers } from 'redux';

import { PasswordRecoveryAction } from '../types';
import {
  passwordRecoveryRequest,
  passwordRecoverySuccess,
  passwordRecoveryFail,
  resetForm,
  passwordResetRequest,
  passwordResetSuccess,
  passwordResetFail,
  resetChanged,
} from '../actions';

const loading = (state = false, action: PasswordRecoveryAction) => {
  switch (action.type) {
    case passwordRecoveryRequest.type:
    case passwordResetRequest.type:
      return true;

    case passwordRecoverySuccess.type:
    case passwordResetSuccess.type:
    case passwordRecoveryFail.type:
    case passwordResetFail.type:
      return false;

    default:
      return state;
  }
};

const error = (state: string | null = null, action: PasswordRecoveryAction) => {
  switch (action.type) {
    case passwordRecoveryRequest.type:
    case passwordRecoverySuccess.type:
    case passwordResetRequest.type:
    case passwordResetSuccess.type:
    case resetForm.type:
    case resetChanged.type:
      return null;

    case passwordRecoveryFail.type:
    case passwordResetFail.type:
      return action.payload.message;

    default:
      return state;
  }
};

const changed = (state = false, action: PasswordRecoveryAction) => {
  switch (action.type) {
    case passwordResetSuccess.type:
      return true;

    case passwordResetFail.type:
    case resetChanged.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers({
  loading,
  error,
  changed,
});
